import { createApi } from '@reduxjs/toolkit/query/react';
import { dynamicBaseQuery } from '../badRequestHandler';

/* ─── Types ──────────────────────────────────────────────────────────── */

interface GetHandoverRequestsParams {
  page?:  number;
  limit?: number;
}

export interface HandoverEmployeeItem {
  _id?:  string;
  name?: string;
}

interface GetHandoverEmployeesParams {
  search?: string;
}

interface AddHandoverRequestArgs {
  employeeId: string;
  amount:     number;
}

/* ─── API ────────────────────────────────────────────────────────────── */

export const handoverApi = createApi({
  reducerPath: 'handoverApi',
  baseQuery:   dynamicBaseQuery,
  tagTypes:    ['HandoverRequest'] as const,
  endpoints:   (builder) => ({
    getHandoverRequests: builder.query<unknown, GetHandoverRequestsParams | void>({
      query: (params) => {
        const { page, limit } = params || {};
        const qp = new URLSearchParams();
        if (page  != null) qp.append('page', String(page));
        if (limit != null) qp.append('limit', String(limit));
        const qs = qp.toString();
        return { url: qs ? `/handover-requests?${qs}` : `/handover-requests`, method: 'GET' };
      },
      providesTags: ['HandoverRequest'],
    }),
    getHandoverEmployees: builder.query<{ data: HandoverEmployeeItem[] }, GetHandoverEmployeesParams | void>({
      query: (params) => {
        const { search } = params || {};
        const qp = new URLSearchParams();
        if (search) qp.append('search', search);
        const qs = qp.toString();
        return { url: qs ? `/handover-requests/employees?${qs}` : `/handover-requests/employees`, method: 'GET' };
      },
    }),
    addHandoverRequest: builder.mutation<unknown, AddHandoverRequestArgs>({
      query: (body) => ({ url: `/handover-requests`, method: 'POST', body }),
      invalidatesTags: ['HandoverRequest'],
    }),
    acceptHandoverRequest: builder.mutation<unknown, string>({
      query: (id) => ({ url: `/handover-requests/${id}/accept`, method: 'PATCH' }),
      invalidatesTags: ['HandoverRequest'],
    }),
    rejectHandoverRequest: builder.mutation<unknown, string>({
      query: (id) => ({ url: `/handover-requests/${id}/reject`, method: 'PATCH' }),
      invalidatesTags: ['HandoverRequest'],
    }),
  }),
});

export const {
  useGetHandoverRequestsQuery,
  useGetHandoverEmployeesQuery,
  useAddHandoverRequestMutation,
  useAcceptHandoverRequestMutation,
  useRejectHandoverRequestMutation,
} = handoverApi;
